import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import ViewAddressHook from "../../hook/user/ViewAddressHook";
import UserAddressCard from "./UserAddressCard";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const UserAllAddress = () => {
  const { t } = useTranslation()
  const [res] = ViewAddressHook();
  const settingsRes = useSelector((state) => state.settingsReducers.settings);

  return (
    <div className="checkout-section-card mb-4 font">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="checkout-section-title mb-0">
          <i className="fa-solid fa-address-book"></i>
          {t("Address book")}
        </div>
        <Link to="/user/add-address" style={{ textDecoration: "none" }}>
          <button 
            className="btn btn-sm text-white fw-bold px-3 py-2" 
            style={{ backgroundColor: settingsRes?.data?.cartColor || settingsRes?.data?.primaryColor || "#3182ce", borderRadius: '8px' }}
          >
            <i className="fa-solid fa-plus me-2"></i>
            {t("add new adress")}
          </button>
        </Link>
      </div>

      <div className="mt-4">
        {res && res.length > 0 ? (
          res.map((item) => (
            <UserAddressCard key={item._id} item={item} />
          ))
        ) : (
          <div className="text-center py-5 text-muted">
            <i className="fa-regular fa-map mb-3 text-secondary" style={{ fontSize: '3rem' }}></i>
            <h5 className="fw-bold">{t("There are no addresses yet.")}</h5>
            <p className="small">أضف عنوانك الأول الآن لتسهيل عملية الطلب.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserAllAddress;
